import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { BacktestDashboard } from '../components/Backtest';

/**
 * BacktestResults Page
 * 
 * Displays backtest results for a specific backtest ID from URL params.
 */
const BacktestResults = () => {
    const { id } = useParams();

    return (
        <div className="min-h-screen bg-base-200 p-6">
            <div className="max-w-7xl mx-auto">
                {/* Breadcrumb Navigation */}
                <div className="text-sm breadcrumbs mb-6">
                    <ul>
                        <li><Link to="/dashboard">Dashboard</Link></li>
                        <li><Link to="/dashboard/backtest">Backtest</Link></li>
                        <li>Results</li>
                    </ul>
                </div>

                {/* Backtest Dashboard */}
                <BacktestDashboard backtestId={id} />
            </div>
        </div>
    );
};

export default BacktestResults;
